import React, { MutableRefObject } from 'react';

const SupernovaDropdownContext = React.createContext<{
    sort: MutableRefObject<((arr: string[]) => string[]) | null>;
    elements: Record<string, HTMLElement | null>;
}>({ sort: { current: null }, elements: {} });

export default SupernovaDropdownContext;
